export default function ConnectWalletButton(){
    function openConnectWalletBox(){
        //console.log('open box')
        window.dispatchEvent(
            new CustomEvent('openConnectBox', {
                detail: true,
            })
        )
    }
    return(  
        <button onClick={openConnectWalletBox} className="w-full select-none whitespace-nowrap px-[3.2rem] py-[1.2rem] text-[1.6rem] text-third rounded-[10rem] transition-all duration-300 active:bg-opacity-50 bg-primary font-bakbak" type="butoon">CONNECT WALLET</button>
    )
}